export const SET_CURRENT_USER = 'app/auth/SET_CURRENT_USER';
export const GET_LOGGED_USER = 'app/auth/GET_LOGGED_USER';
export const CLEAR_CURRENT_USER = 'app/auth/CLEAR_CURRENT_USER';
export const CLEAR_RESPONSE = 'app/auth/CLEAR_RESPONSE';
